import { LoadState } from "../../../constants/enum";
import { ITemplate, ITemplateState } from "./templates.types";


export const defaultTemplate: ITemplate = {
    templates_id: 0,
    template_code: null,
    related_module: null,
    template_name: "",
    template_category: "",
    call_type: "",
    table_name_or_dynamic_view_code: "",
    template_subject: null,
    body: "",
    under_variable_data_would_bind: "",
    status: "ACTIVE",
    created_by_id: null,
    track_changes: ""
}


export const defaultTemplateState: ITemplateState = {
    multiple_teplates_list: {
        loading: LoadState.idle,
        data: [],
        count: 0,
        error: null,
    },
    single_template: {
        loading: LoadState.idle,
        data: defaultTemplate,
        error: null,
    }
}
